// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sa-blue: #006cb8;
  --sa-blue-dark: #005282;
  --sa-blue-mid: #046eac;
  --sa-blue-soft: #eaf3ff;
  --sa-bg: #f4f7fb;
  --sa-surface: #ffffff;
  --sa-border: #d9e2ec;
  --sa-text: #1e293b;
  --sa-muted: #64748b;
  --sa-radius: 12px;
  --sa-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  --sa-shadow-lg: 0 12px 24px rgba(15, 23, 42, 0.1);
  --sa-pill: linear-gradient(178.14deg, #005282 1.57%, #046eac 115.33%);
}

/* ---------- Content shell ---------- */
.ant-layout.admin .ant-layout-content {
  background: var(--sa-bg);
}

.ant-layout.admin .content-wrapper {
  padding: 20px;
}

.ant-layout.admin .content-wrapper--flush {
  padding: 0;
}

/* ---------- Top bar ---------- */
.ant-layout .ant-layout-header.app-topbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 66px;
  padding: 0 24px;
  line-height: 1.2;
  background: linear-gradient(90deg, #f4f9ff 0%, #dcecff 60%, #cfe4fb 100%);
  box-shadow: 0 2px 10px rgba(3, 73, 122, 0.08);
  position: relative;
  z-index: 10;
}

.app-topbar .app-topbar__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: linear-gradient(178.14deg, #005282 20%, #046eac 50%, #005282 80%);
  background-size: 150% 150%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: app-topbar-soft-gradient 14s linear infinite;
}

@keyframes app-topbar-soft-gradient {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.app-topbar .app-topbar__actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-topbar .app-topbar__menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 10px;
  background: #fff;
  color: var(--sa-blue);
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(3, 73, 122, 0.1);
  cursor: pointer;
}

.app-topbar .um-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 12px 0 4px;
  border: 0;
  border-radius: 999px;
  background: var(--sa-pill);
  color: #fff;
  cursor: pointer;
  transition: filter 0.15s ease, box-shadow 0.15s ease;
}

.app-topbar .um-pill:hover,
.app-topbar .um-pill-open {
  filter: brightness(1.12);
  box-shadow: 0 2px 10px rgba(0, 82, 130, 0.35);
}

.app-topbar .um-pill:focus-visible {
  outline: 2px solid #7cc4f5;
  outline-offset: 2px;
}

.app-topbar .um-pill-avatar {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.85);
  background: #fff;
}

.app-topbar .um-pill-name {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.app-topbar .um-pill-chevron {
  font-size: 11px;
  color: #fff;
  transition: transform 0.2s ease;
}

.app-topbar .um-pill-open .um-pill-chevron {
  transform: rotate(180deg);
}

.user-menu-popover {
  width: 248px;
  max-width: 92vw;
  z-index: 1050;
}

.user-menu-popover .ant-popover-inner {
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 40, 70, 0.16);
}

.user-menu-popover .um-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 4px 0;
}

.user-menu-popover .um-card-avatar {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  box-shadow: 0 0 0 1.5px #fff, 0 0 0 3px var(--sa-blue);
}

.user-menu-popover .um-card-identity {
  min-width: 0;
  flex: 1 1;
}

.user-menu-popover .um-card-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--sa-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-popover .um-card-role,
.user-menu-popover .um-card-email {
  font-size: 11.5px;
  line-height: 1.35;
  color: var(--sa-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-popover .um-divider {
  height: 1px;
  margin: 8px 0;
  background: #e8eef4;
}

.user-menu-popover .um-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 13px;
  color: var(--sa-text);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.user-menu-popover .um-menu-item:hover,
.user-menu-popover .um-menu-item:focus-visible {
  background: #eaf4fc;
  color: var(--sa-blue);
  outline: none;
}

.user-menu-popover .um-menu-item--danger,
.user-menu-popover .um-menu-item--danger:hover,
.user-menu-popover .um-menu-item--danger:focus-visible {
  color: #d92d20;
}

.user-menu-popover .um-menu-item--danger:hover,
.user-menu-popover .um-menu-item--danger:focus-visible {
  background: #fdecea;
}

/* ---------- Page title card ---------- */
.page-title-wrapper.page-title-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  margin: 0 0 20px;
  padding: 14px 20px;
  text-align: left;
  background: var(--sa-surface);
  border: 1px solid var(--sa-border);
  border-radius: 10px;
  box-shadow: var(--sa-shadow);
}

.page-title-wrapper.page-title-wrapper .heading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.page-title-wrapper.page-title-wrapper .heading::before {
  content: "";
  flex: 0 0 auto;
  width: 4px;
  height: 24px;
  background: #168df5;
  border-radius: 4px;
}

.page-title-wrapper.page-title-wrapper .heading h2 {
  margin: 0;
  color: #006db6;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
}

.page-title-wrapper.page-title-wrapper .heading .heading-sub {
  color: var(--sa-muted);
  font-size: 13px;
}

.page-title-wrapper.page-title-wrapper .header-btns {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.page-title-wrapper.page-title-wrapper .ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(:disabled) {
  background: #fff;
  color: #185d87;
  border: 1px solid #185d87;
  font-weight: 600;
}

.page-title-wrapper.page-title-wrapper .ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(:disabled):hover {
  background: var(--sa-blue-soft);
  color: var(--sa-blue-dark);
  border-color: var(--sa-blue-dark);
}

.page-title-wrapper.page-title-wrapper .ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
}

.page-title-wrapper.page-title-wrapper .ant-select .ant-select-selector {
  height: 36px;
  align-items: center;
  border-radius: 6px;
}

.page-title-wrapper.page-title-wrapper .ant-btn-primary {
  font-weight: 600;
}

.page-title-wrapper.page-title-wrapper .ant-btn-primary:not(:disabled) {
  border: 0;
  background: var(--sa-pill);
  color: #fff;
  transition: filter 0.2s ease, transform 0.2s ease;
}

.page-title-wrapper.page-title-wrapper .ant-btn-primary:not(:disabled):hover {
  background: var(--sa-pill);
  color: #fff;
  filter: brightness(1.12);
  transform: translateY(-1px);
}

/* ---------- Table card ---------- */
body.admin-user .ant-layout.admin .ant-layout-content .ant-card.main-content-wrapper .ant-card-body {
  background: var(--sa-surface);
  border: 0;
  border-radius: 20px;
  box-shadow: 0 7px 32px 0 #ebeced;
  padding: 20px;
}

body.admin-user .ant-layout.admin .ant-layout-content .search-wrapper {
  background: #f6f9fc;
  border: 1px solid #e6edf4;
}

body.admin-user .ant-layout.admin .ant-layout-content .ant-table-container table .ant-table-thead th {
  background: #eef3f8;
  color: #1f3a52;
}

body.admin-user .ant-layout.admin .ant-layout-content .ant-table-container table .ant-table-tbody tr:hover > td {
  background: #f5faff;
}

/* ---------- Search bar, filter buttons (HRMS / Payroll standard) ---------- */
.search-wrapper .search {
  width: 100%;
  max-width: 320px;
}

.ant-layout.admin .ant-layout-content .main-table-wrapper .ant-btn.ch-view-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 8px;
}

.ant-layout.admin .ant-layout-content .main-table-wrapper .ant-btn.ch-view-btn:hover {
  background: var(--sa-blue-soft);
}

.search-wrapper .ant-input-search .ant-input-affix-wrapper,
.search-wrapper .ant-input-search .ant-input-search-button {
  height: 36px;
}

.search-wrapper .ant-input-search .ant-input-search-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.filter-btns-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.ant-layout.admin .ant-btn.btn-secondary,
.ant-modal .ant-btn.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  background: #fff;
  color: #005282;
  border: 1px solid #005282;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: none;
}

.ant-layout.admin .ant-btn.btn-secondary:not(:disabled):hover,
.ant-modal .ant-btn.btn-secondary:not(:disabled):hover {
  background: var(--sa-blue-soft);
  color: #005282;
  border-color: #005282;
}

.ant-layout.admin .ant-btn.filter-btn {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: none;
  transition: all 0.3s ease-in-out;
}

.ant-layout.admin .ant-btn.filter-btn:not(:disabled):hover {
  background: #bae6fd;
  color: #0369a1;
  border-color: #7dd3fc;
}

.ant-layout.admin .ant-btn.btn-secondary:disabled,
.ant-modal .ant-btn.btn-secondary:disabled,
.ant-layout.admin .ant-btn.filter-btn:disabled {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
}

/* ---------- Tabs (HRMS standard: no tab padding, ink bar only) ---------- */
.ant-layout.admin .ant-tabs .ant-tabs-nav {
  margin-bottom: 16px;
}

.ant-layout.admin .ant-tabs .ant-tabs-nav::before {
  border-bottom: 1px solid #e8e8e8;
}

.ant-layout.admin .ant-tabs .ant-tabs-tab {
  padding: 12px 0;
  font-size: 14px;
}

.ant-layout.admin .ant-tabs .ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 32px;
}

.ant-layout.admin .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {
  color: rgba(0, 0, 0, 0.85);
}

.ant-layout.admin .ant-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: #28aaeb;
}

.ant-layout.admin .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #038fde;
  font-weight: 500;
}

.ant-layout.admin .ant-tabs .ant-tabs-ink-bar {
  background: #038fde;
}

.ant-layout.admin .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn {
  color: rgba(0, 0, 0, 0.35);
}

/* ---------- Pagination ---------- */
.ant-pagination.ant-pagination.ant-pagination {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 100%;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  row-gap: 8px;
  margin: 0;
  padding: 14px 16px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-inline: 0 auto;
  line-height: 32px;
  color: #545454;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item {
  min-width: 32px;
  height: 32px;
  margin-inline-end: 8px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: #545454;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item:hover {
  border-color: #038fde;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item:hover a {
  color: #038fde;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active {
  font-weight: 500;
  background-color: #15507b;
  border-color: #15507b;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a {
  color: #fff;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active:hover {
  background-color: #fff;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active:hover a {
  color: #15507b;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-jump-prev,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-jump-next {
  min-width: 32px;
  height: 32px;
  margin-inline-end: 8px;
  line-height: 32px;
  text-align: center;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev button,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next button {
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #545454;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.3s;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev:hover button,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next:hover button {
  color: #038fde;
  border-color: #038fde;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-disabled button,
.ant-pagination.ant-pagination.ant-pagination .ant-pagination-disabled:hover button {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options {
  display: inline-flex;
  align-items: center;
  margin-inline-start: 8px;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options .ant-select .ant-select-selector {
  height: 32px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options .ant-select .ant-select-selection-item {
  line-height: 30px;
  color: #545454;
}

/* containers that already pad their content supply the gutter */
.main-content-wrapper .ant-pagination.ant-pagination.ant-pagination,
.pm-table-inner .ant-pagination.ant-pagination.ant-pagination {
  padding: 16px 0 0;
}

/* ---------- Responsive ---------- */
@media (max-width: 991px) {
  .ant-layout .ant-layout-header.app-topbar {
    padding: 0 12px;
    gap: 8px;
  }

  .app-topbar .app-topbar__title {
    font-size: 18px;
  }

  .app-topbar .um-pill-name {
    max-width: 100px;
  }

  .ant-layout.admin .content-wrapper {
    padding: 12px;
  }
}

@media (max-width: 767px) {
  .ant-layout.admin .content-wrapper:not(.content-wrapper--flush) {
    padding: 8px;
  }
}

@media (max-width: 575px) {
  .app-topbar .app-topbar__title {
    font-size: 16px;
  }

  .app-topbar .um-pill-name {
    display: none;
  }

  .page-title-wrapper.page-title-wrapper {
    padding: 12px 14px;
  }

  .page-title-wrapper.page-title-wrapper .heading h2 {
    font-size: 18px;
  }

  .ant-pagination.ant-pagination.ant-pagination {
    justify-content: center;
  }

  .ant-pagination.ant-pagination.ant-pagination .ant-pagination-total-text {
    width: 100%;
    margin-inline: 0;
    text-align: center;
  }
}

/* ---------- Table column picker (Health, HRMS admins) ---------- */
.ch-colpicker {
  width: 280px;
  max-height: 360px;
  overflow-y: auto;
}

.ch-colpicker-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.ch-colpicker-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
  border-top: 1px solid #eef1f5;
}

.ch-colpicker-group .ant-checkbox-wrapper {
  margin: 0;
}

.ch-colpicker-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,iDAAiD;EACjD,qEAAqE;AACvE;;AAEA,wCAAwC;AACxC;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yEAAyE;EACzE,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6EAA6E;EAC7E,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,oDAAoD;AACtD;;AAEA;;EAEE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,6EAA6E;AAC7E;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;;EAEE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[":root {\n  --sa-blue: #006cb8;\n  --sa-blue-dark: #005282;\n  --sa-blue-mid: #046eac;\n  --sa-blue-soft: #eaf3ff;\n  --sa-bg: #f4f7fb;\n  --sa-surface: #ffffff;\n  --sa-border: #d9e2ec;\n  --sa-text: #1e293b;\n  --sa-muted: #64748b;\n  --sa-radius: 12px;\n  --sa-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  --sa-shadow-lg: 0 12px 24px rgba(15, 23, 42, 0.1);\n  --sa-pill: linear-gradient(178.14deg, #005282 1.57%, #046eac 115.33%);\n}\n\n/* ---------- Content shell ---------- */\n.ant-layout.admin .ant-layout-content {\n  background: var(--sa-bg);\n}\n\n.ant-layout.admin .content-wrapper {\n  padding: 20px;\n}\n\n.ant-layout.admin .content-wrapper--flush {\n  padding: 0;\n}\n\n/* ---------- Top bar ---------- */\n.ant-layout .ant-layout-header.app-topbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  height: 66px;\n  padding: 0 24px;\n  line-height: 1.2;\n  background: linear-gradient(90deg, #f4f9ff 0%, #dcecff 60%, #cfe4fb 100%);\n  box-shadow: 0 2px 10px rgba(3, 73, 122, 0.08);\n  position: relative;\n  z-index: 10;\n}\n\n.app-topbar .app-topbar__title {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: linear-gradient(178.14deg, #005282 20%, #046eac 50%, #005282 80%);\n  background-size: 150% 150%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  animation: app-topbar-soft-gradient 14s linear infinite;\n}\n\n@keyframes app-topbar-soft-gradient {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n\n.app-topbar .app-topbar__actions {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-topbar .app-topbar__menu-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 auto;\n  border: 0;\n  border-radius: 10px;\n  background: #fff;\n  color: var(--sa-blue);\n  font-size: 18px;\n  box-shadow: 0 2px 8px rgba(3, 73, 122, 0.1);\n  cursor: pointer;\n}\n\n.app-topbar .um-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 12px 0 4px;\n  border: 0;\n  border-radius: 999px;\n  background: var(--sa-pill);\n  color: #fff;\n  cursor: pointer;\n  transition: filter 0.15s ease, box-shadow 0.15s ease;\n}\n\n.app-topbar .um-pill:hover,\n.app-topbar .um-pill-open {\n  filter: brightness(1.12);\n  box-shadow: 0 2px 10px rgba(0, 82, 130, 0.35);\n}\n\n.app-topbar .um-pill:focus-visible {\n  outline: 2px solid #7cc4f5;\n  outline-offset: 2px;\n}\n\n.app-topbar .um-pill-avatar {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  background: #fff;\n}\n\n.app-topbar .um-pill-name {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.app-topbar .um-pill-chevron {\n  font-size: 11px;\n  color: #fff;\n  transition: transform 0.2s ease;\n}\n\n.app-topbar .um-pill-open .um-pill-chevron {\n  transform: rotate(180deg);\n}\n\n.user-menu-popover {\n  width: 248px;\n  max-width: 92vw;\n  z-index: 1050;\n}\n\n.user-menu-popover .ant-popover-inner {\n  padding: 10px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 40, 70, 0.16);\n}\n\n.user-menu-popover .um-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 2px 4px 0;\n}\n\n.user-menu-popover .um-card-avatar {\n  width: 42px;\n  height: 42px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #fff;\n  box-shadow: 0 0 0 1.5px #fff, 0 0 0 3px var(--sa-blue);\n}\n\n.user-menu-popover .um-card-identity {\n  min-width: 0;\n  flex: 1;\n}\n\n.user-menu-popover .um-card-name {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--sa-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu-popover .um-card-role,\n.user-menu-popover .um-card-email {\n  font-size: 11.5px;\n  line-height: 1.35;\n  color: var(--sa-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu-popover .um-divider {\n  height: 1px;\n  margin: 8px 0;\n  background: #e8eef4;\n}\n\n.user-menu-popover .um-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  height: 34px;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 13px;\n  color: var(--sa-text);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.user-menu-popover .um-menu-item:hover,\n.user-menu-popover .um-menu-item:focus-visible {\n  background: #eaf4fc;\n  color: var(--sa-blue);\n  outline: none;\n}\n\n.user-menu-popover .um-menu-item--danger,\n.user-menu-popover .um-menu-item--danger:hover,\n.user-menu-popover .um-menu-item--danger:focus-visible {\n  color: #d92d20;\n}\n\n.user-menu-popover .um-menu-item--danger:hover,\n.user-menu-popover .um-menu-item--danger:focus-visible {\n  background: #fdecea;\n}\n\n/* ---------- Page title card ---------- */\n.page-title-wrapper.page-title-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: 100%;\n  margin: 0 0 20px;\n  padding: 14px 20px;\n  text-align: left;\n  background: var(--sa-surface);\n  border: 1px solid var(--sa-border);\n  border-radius: 10px;\n  box-shadow: var(--sa-shadow);\n}\n\n.page-title-wrapper.page-title-wrapper .heading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.page-title-wrapper.page-title-wrapper .heading::before {\n  content: \"\";\n  flex: 0 0 auto;\n  width: 4px;\n  height: 24px;\n  background: #168df5;\n  border-radius: 4px;\n}\n\n.page-title-wrapper.page-title-wrapper .heading h2 {\n  margin: 0;\n  color: #006db6;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.page-title-wrapper.page-title-wrapper .heading .heading-sub {\n  color: var(--sa-muted);\n  font-size: 13px;\n}\n\n.page-title-wrapper.page-title-wrapper .header-btns {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(:disabled) {\n  background: #fff;\n  color: #185d87;\n  border: 1px solid #185d87;\n  font-weight: 600;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(:disabled):hover {\n  background: var(--sa-blue-soft);\n  color: var(--sa-blue-dark);\n  border-color: var(--sa-blue-dark);\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 6px;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-select .ant-select-selector {\n  height: 36px;\n  align-items: center;\n  border-radius: 6px;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn-primary {\n  font-weight: 600;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn-primary:not(:disabled) {\n  border: 0;\n  background: var(--sa-pill);\n  color: #fff;\n  transition: filter 0.2s ease, transform 0.2s ease;\n}\n\n.page-title-wrapper.page-title-wrapper .ant-btn-primary:not(:disabled):hover {\n  background: var(--sa-pill);\n  color: #fff;\n  filter: brightness(1.12);\n  transform: translateY(-1px);\n}\n\n/* ---------- Table card ---------- */\nbody.admin-user .ant-layout.admin .ant-layout-content .ant-card.main-content-wrapper .ant-card-body {\n  background: var(--sa-surface);\n  border: 0;\n  border-radius: 20px;\n  box-shadow: 0 7px 32px 0 #ebeced;\n  padding: 20px;\n}\n\nbody.admin-user .ant-layout.admin .ant-layout-content .search-wrapper {\n  background: #f6f9fc;\n  border: 1px solid #e6edf4;\n}\n\nbody.admin-user .ant-layout.admin .ant-layout-content .ant-table-container table .ant-table-thead th {\n  background: #eef3f8;\n  color: #1f3a52;\n}\n\nbody.admin-user .ant-layout.admin .ant-layout-content .ant-table-container table .ant-table-tbody tr:hover > td {\n  background: #f5faff;\n}\n\n/* ---------- Search bar, filter buttons (HRMS / Payroll standard) ---------- */\n.search-wrapper .search {\n  width: 100%;\n  max-width: 320px;\n}\n\n.ant-layout.admin .ant-layout-content .main-table-wrapper .ant-btn.ch-view-btn {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 8px;\n}\n\n.ant-layout.admin .ant-layout-content .main-table-wrapper .ant-btn.ch-view-btn:hover {\n  background: var(--sa-blue-soft);\n}\n\n.search-wrapper .ant-input-search .ant-input-affix-wrapper,\n.search-wrapper .ant-input-search .ant-input-search-button {\n  height: 36px;\n}\n\n.search-wrapper .ant-input-search .ant-input-search-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-btns-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.ant-layout.admin .ant-btn.btn-secondary,\n.ant-modal .ant-btn.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  background: #fff;\n  color: #005282;\n  border: 1px solid #005282;\n  border-radius: 6px;\n  font-weight: 500;\n  box-shadow: none;\n}\n\n.ant-layout.admin .ant-btn.btn-secondary:not(:disabled):hover,\n.ant-modal .ant-btn.btn-secondary:not(:disabled):hover {\n  background: var(--sa-blue-soft);\n  color: #005282;\n  border-color: #005282;\n}\n\n.ant-layout.admin .ant-btn.filter-btn {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 16px;\n  background: #e0f2fe;\n  color: #0369a1;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  font-weight: 500;\n  box-shadow: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.ant-layout.admin .ant-btn.filter-btn:not(:disabled):hover {\n  background: #bae6fd;\n  color: #0369a1;\n  border-color: #7dd3fc;\n}\n\n.ant-layout.admin .ant-btn.btn-secondary:disabled,\n.ant-modal .ant-btn.btn-secondary:disabled,\n.ant-layout.admin .ant-btn.filter-btn:disabled {\n  background: #f5f5f5;\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n}\n\n/* ---------- Tabs (HRMS standard: no tab padding, ink bar only) ---------- */\n.ant-layout.admin .ant-tabs .ant-tabs-nav {\n  margin-bottom: 16px;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-nav::before {\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab {\n  padding: 12px 0;\n  font-size: 14px;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab + .ant-tabs-tab {\n  margin: 0 0 0 32px;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {\n  color: #28aaeb;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #038fde;\n  font-weight: 500;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-ink-bar {\n  background: #038fde;\n}\n\n.ant-layout.admin .ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn {\n  color: rgba(0, 0, 0, 0.35);\n}\n\n/* ---------- Pagination ---------- */\n.ant-pagination.ant-pagination.ant-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 1 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  row-gap: 8px;\n  margin: 0;\n  padding: 14px 16px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-total-text {\n  display: inline-block;\n  height: 32px;\n  margin-inline: 0 auto;\n  line-height: 32px;\n  color: #545454;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item {\n  min-width: 32px;\n  height: 32px;\n  margin-inline-end: 8px;\n  line-height: 30px;\n  text-align: center;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item a {\n  display: block;\n  padding: 0 6px;\n  color: #545454;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item:hover {\n  border-color: #038fde;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item:hover a {\n  color: #038fde;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active {\n  font-weight: 500;\n  background-color: #15507b;\n  border-color: #15507b;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active a {\n  color: #fff;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active:hover {\n  background-color: #fff;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-item.ant-pagination-item-active:hover a {\n  color: #15507b;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-jump-prev,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-jump-next {\n  min-width: 32px;\n  height: 32px;\n  margin-inline-end: 8px;\n  line-height: 32px;\n  text-align: center;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev button,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next button {\n  width: 100%;\n  height: 100%;\n  font-size: 12px;\n  color: #545454;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-prev:hover button,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-next:hover button {\n  color: #038fde;\n  border-color: #038fde;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-disabled button,\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-disabled:hover button {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options {\n  display: inline-flex;\n  align-items: center;\n  margin-inline-start: 8px;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options .ant-select .ant-select-selector {\n  height: 32px;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n\n.ant-pagination.ant-pagination.ant-pagination .ant-pagination-options .ant-select .ant-select-selection-item {\n  line-height: 30px;\n  color: #545454;\n}\n\n/* containers that already pad their content supply the gutter */\n.main-content-wrapper .ant-pagination.ant-pagination.ant-pagination,\n.pm-table-inner .ant-pagination.ant-pagination.ant-pagination {\n  padding: 16px 0 0;\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 991px) {\n  .ant-layout .ant-layout-header.app-topbar {\n    padding: 0 12px;\n    gap: 8px;\n  }\n\n  .app-topbar .app-topbar__title {\n    font-size: 18px;\n  }\n\n  .app-topbar .um-pill-name {\n    max-width: 100px;\n  }\n\n  .ant-layout.admin .content-wrapper {\n    padding: 12px;\n  }\n}\n\n@media (max-width: 767px) {\n  .ant-layout.admin .content-wrapper:not(.content-wrapper--flush) {\n    padding: 8px;\n  }\n}\n\n@media (max-width: 575px) {\n  .app-topbar .app-topbar__title {\n    font-size: 16px;\n  }\n\n  .app-topbar .um-pill-name {\n    display: none;\n  }\n\n  .page-title-wrapper.page-title-wrapper {\n    padding: 12px 14px;\n  }\n\n  .page-title-wrapper.page-title-wrapper .heading h2 {\n    font-size: 18px;\n  }\n\n  .ant-pagination.ant-pagination.ant-pagination {\n    justify-content: center;\n  }\n\n  .ant-pagination.ant-pagination.ant-pagination .ant-pagination-total-text {\n    width: 100%;\n    margin-inline: 0;\n    text-align: center;\n  }\n}\n\n/* ---------- Table column picker (Health, HRMS admins) ---------- */\n.ch-colpicker {\n  width: 280px;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.ch-colpicker-actions {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.ch-colpicker-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 0;\n  border-top: 1px solid #eef1f5;\n}\n\n.ch-colpicker-group .ant-checkbox-wrapper {\n  margin: 0;\n}\n\n.ch-colpicker-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
